import { setFontFamilyCSSVariables } from "./js/bb-font-family-override";

/**
 * initialize it all
 */
function loadCustomJs() {
  setFontFamilyCSSVariables();
  //console.log('custom JS from plugin')
}
window.loadCustomJs = loadCustomJs; // append to window for beaver builder refreshing

document.addEventListener("DOMContentLoaded", function () {
  loadCustomJs();
});
